import { Link } from "react-router-dom";

export default function HelpCta() {
  return (
    <section className="bg-background-100 border-t border-background-200 pb-16 md:pb-24 pt-14 md:pt-20">
      <div className="max-w-editorial mx-auto px-4 md:px-8">
        <div className="relative overflow-hidden rounded-lg bg-secondary-900 px-6 py-12 md:px-14 md:py-16">
          <div className="absolute -right-16 -top-16 w-64 h-64 rounded-full bg-secondary-800/50"></div>
          <div className="absolute -left-10 bottom-0 w-40 h-40 rounded-full bg-primary-700/30"></div>

          <div className="relative grid grid-cols-1 lg:grid-cols-12 gap-8 items-center">
            <div className="lg:col-span-8">
              <span className="inline-flex items-center gap-2 text-xs tracking-[0.2em] text-accent-400 uppercase">
                <i className="ri-hand-heart-line"></i>
                如果你正在经历这一切
              </span>
              <h2 className="mt-4 font-heading text-2xl md:text-3xl font-bold text-background-50 leading-snug">
                你不需要先证明自己「值得被相信」，才有资格求助
              </h2>
              <p className="mt-4 text-sm md:text-base leading-relaxed text-background-200/85 max-w-2xl">
                把发生的经过告诉我们，或直接查看求助渠道与心理援助指引。信息会被严格保密，未经许可不会公开任何内容。
              </p>
            </div>
            <div className="lg:col-span-4 flex flex-col sm:flex-row lg:flex-col gap-3 lg:items-stretch">
              <Link
                to="/about#help"
                className="inline-flex items-center justify-center gap-2 px-6 py-3.5 rounded-md text-sm font-medium whitespace-nowrap cursor-pointer bg-accent-500 text-secondary-950 hover:bg-accent-600 transition-colors"
              >
                <i className="ri-mail-send-line"></i>
                写信给编辑部
              </Link>
              <Link
                to="/knowledge#emergency"
                className="inline-flex items-center justify-center gap-2 px-6 py-3.5 rounded-md text-sm font-medium whitespace-nowrap cursor-pointer border border-background-100/40 text-background-50 hover:bg-background-50/10 transition-colors"
              >
                <i className="ri-alarm-warning-line"></i>
                紧急求助指引
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}